import { useRef, useState } from 'react'

export function useChartCursor(tooltipW: number) {
	const containerRef = useRef<HTMLDivElement>(null)
	const [cursorPos, setCursorPos] = useState<{ x: number; y: number } | undefined>()

	const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
		if (containerRef.current) {
			const rect = containerRef.current.getBoundingClientRect()
			const mouseX = e.clientX - rect.left
			const mouseY = e.clientY - rect.top
			const wouldOverflowRight = e.clientX + 16 + tooltipW > window.innerWidth
			const x = wouldOverflowRight ? mouseX - tooltipW - 8 : mouseX + 16
			setCursorPos({ x, y: mouseY - 10 })
		}
	}

	const onMouseLeave = () => setCursorPos(undefined)

	return { containerRef, cursorPos, onMouseMove, onMouseLeave }
}
